import { ReactNode, useState } from 'react'
import { SettingsContext } from './definition'

export const SettingsProvider = ({ children }: { children: ReactNode }) => {
  const [settings, setSettings] = useState({
    location: localStorage.getItem('settings.home_office'),
  })

  const updateLocation = (
    office_location: string,
    initialUpdate: boolean = false,
  ) => {
    if (initialUpdate) {
      localStorage.setItem('settings.home_office', office_location)
    }
    setSettings((prev) => ({
      ...prev,
      location: office_location,
    }))
  }

  const cleanupSettings = () => {
    localStorage.removeItem('settings.home_office')
  }

  return (
    <SettingsContext.Provider
      value={{
        updateLocation,
        cleanupSettings,
        settings: JSON.stringify(settings),
      }}
    >
      {children}
    </SettingsContext.Provider>
  )
}
